/**
 * @desc 导入对私账户
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basic/staffPaymentInfo/staffPaymentInfoImport`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
